import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import { IListType } from "../store";
import activityLogDataAccess from "src/dataAccess/ActivityLog/activityLogDataAccess";



interface IActivityLogListType extends IListType {
  source: any; 
}

export const getActivityLogListSuccess = createAction<any>(
    "[Activity Log] Get Activity Log List Success"
  );
  export const loadingList = createAction<boolean>("[Activity Log] Loading list");
  export const GetActivityLogList = createAsyncThunk<any, IActivityLogListType>(
    "[ActivityLog] Get Activity Log List",
    async (parameter, thunkAPI) => {
      thunkAPI.dispatch(loadingList(true));
      const result = await activityLogDataAccess.getList(parameter).then((res) => {
        console.log(res.data);
        thunkAPI.dispatch(getActivityLogListSuccess(res));
        thunkAPI.dispatch(loadingList(false));
        return res;
      });
      return result;
    }
  );
  export const clearActivityLogList = createAction("[Activity Log] Clear List");